import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-logout-callback',
    templateUrl: './logout-callback.component.html',
    standalone: true,
})
export class LogoutCallbackComponent implements OnInit {


    public processingText='';

    constructor(private readonly router: Router){}

    ngOnInit() {
        const lastRoute = sessionStorage.getItem('lastRoute');
        if(lastRoute){
            this.processingText = 'Processing logout...';
        }
        this.router.navigateByUrl(lastRoute);
    }
}